<template>
  <h1>404 - 页面不存在</h1>
  <p>Hi, there! Nice to meet you!</p>
  <p>你可以在我的网站中迷失页面，但不要在生活中迷失自我！😜</p>
</template>
